import React, { useEffect, useState, useRef } from 'react';
import FilterDropdown from './FilterDropdown';
import ActionButtons from './ActionButtons';
import { useQueryBuilder } from '../context/QueryBuilderContext';
import { FILTER_OPERATORS } from '../../../utils/constants';
import Info from '../../../../Info/Info';
import Paragraph from '../../../../Typography/Paragraph/Paragraph';

const LocaleFilterDropdown = ({ closeDropdown, localesWithFallback, setInitialState, initalState }) => {
  const { queryBuilder, setCondition, removeCondition, getConditionValue } = useQueryBuilder();
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [searchText, setSearchText] = useState('');

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const clearAll = () => {
    setSelectedItems([]);
  };

  const applyFilter = () => {
    if (selectedItems.length > 0) {
      setCondition('locale', FILTER_OPERATORS.IN, selectedItems);
      setInitialState(false);
    } else {
      setCondition('locale', FILTER_OPERATORS.IN, localesWithFallback?.map((item) => item.code));
      setInitialState(true);
    }
    closeDropdown();
  };

  useEffect(() => {
    if (!initalState) {
      const existing = getConditionValue('locale');
      if (existing?.[FILTER_OPERATORS.IN]) {
        setSelectedItems(existing[FILTER_OPERATORS.IN]);
      }
    }
  }, [queryBuilder]);

  return (
    <div>
      <input
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder={'Start typing to see results...'}
        style={{ width: '100%', padding: '8px', marginBottom: '8px', boxSizing: 'border-box' }}
      />

      <Info
        testId="cs-entries-recent-searches-info"
        content={
          <div>
            <Paragraph variant="p3" variantStyle="regular" text={'The languages shown here include the master, current language selection and its fallback defined in the stack.'} />
          </div>
        }
        type="light"
        dismissable={false}
        version="v2"
      />

      <div
        ref={dropdownRef}
        style={{ maxHeight: '300px', overflowY: 'auto' }}
      >
        <FilterDropdown
          data={localesWithFallback.map((item) => ({ name: item.name, id: item.code, fallback_locale: item.fallback_locale }))}
          field="name"
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          loading={false}
        />
      </div>

      <ActionButtons
        closeDropdown={closeDropdown}
        clearAll={clearAll}
        applyFilter={applyFilter}
      />
    </div>
  );
};

export default LocaleFilterDropdown;
